module.exports = __webpack_public_path__ + "img/PNG.4b0a4ff1.svg";